import styled from 'styled-components'
import IndexContentContainer from '../../index/IndexContentContainer'
import RowSpacer from '../../../common/styles/RowSpacer'
import LoadingBar from '../../../common/LoadingBar'
import BooksitoutImages from '../../../images/BooksitoutImages'
import { Author } from '../../../common/Author'

const BookMineLoadingCard = () => {
	return (
		<Container>
			<IndexContentContainer marginBottom={0}>
				<ContentContainer>
                    <div>
					    <Cover src={BooksitoutImages.Placeholder.bookCoverLoading} />
                    </div>
					<RowSpacer size={12.5} />

					<Title>
						<LoadingBar size={8} />
					</Title>

					<RowSpacer size={2.5} />

					<Author>
						<LoadingBar size={4} />
					</Author>

					<RowSpacer size={5} />
					<ProgressBarPlaceholder />
				</ContentContainer>
			</IndexContentContainer>
		</Container>
	)
}

const Container = styled.a.attrs({
	className: 'not-clickable',
})`
	padding-left: 2px;
	padding-right: 2px;

	height: 300px;
`

const ContentContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	text-align: center;
	width: 100%;
`

const Cover = styled.img.attrs({
	className: 'img-fluid rounded',
})`
	max-height: 150px;
	min-height: 150px;
	height: auto;
	width: auto;
	max-width: 100%;
	object-fit: contain;
    border-radius: 10px;
`

const Title = styled.h1.attrs({
	className: 'clamp-1-line',
})`
	font-size: 15px;
	text-align: center;
`

const ProgressBarPlaceholder = styled.div`
	width: 100%;
	height: 6px;
	background-color: #e0e0e0;
	border-radius: 3px;
`

export default BookMineLoadingCard
